import { useDebounceCallback } from '@react-hook/debounce';
import { useState, useEffect, useRef } from 'react';

const useListScrollToBottom = ({ callback, enabled = true, items }) => {
  const [hasTriggeredScrollToBottom, setHasTriggeredScrollToBottom] =
    useState(false);
  const listRef = useRef(null);

  const handleScroll = useDebounceCallback(
    scrollProps => {
      const listProps = listRef.current?.props;

      if (!enabled || !listProps || !callback || hasTriggeredScrollToBottom)
        return;

      const scrollTop = scrollProps.scrollOffset;
      const scrollHeight = items.length * listProps.itemSize; // itemSize * itemCount
      const clientHeight = listProps.height;

      const isOnBottom = scrollTop + clientHeight >= scrollHeight;

      if (isOnBottom) {
        callback();
        setHasTriggeredScrollToBottom(true);
      }
    },
    [enabled, callback, hasTriggeredScrollToBottom, items],
    300
  );

  useEffect(() => {
    setHasTriggeredScrollToBottom(false);
  }, [items]);

  return {
    handleScroll,
    listRef
  };
};

export default useListScrollToBottom;
